<template>
    <div class="c-startpage-hero-element-tile-simple simple-banner entry lg:h-[500px] w-full">
        <NuxtLink :to="entry?.cta?.url" class="flex flex-col gap-8 items-center w-full" :external="true">
          <div v-if="entry.image && (entry.image.alt || entry.altText || entry?.description)" class="w-full">
            <img fetchpriority="high" class="lg:h-[500px] w-full" :src="entry.image.url" :alt="entry.image.alt && entry.image.alt != '' ? entry.image.alt : entry.altText && entry.altText != '' ? entry.altText : entry?.description">
          </div>
        </NuxtLink>
    </div>
</template>
<script setup lang="ts">
interface Entry {
  cta: { label: string; url: string };
  image: { url:string, alt:string };
  badge?: string[];
  headline?: string;
  description?: string;
  type: string;
  altText?: string;
}

defineProps<{
  entry: Entry;
}>();
</script>
